import { render } from "./AddPetBreed.vue?vue&type=template&id=c9b3ab90&scoped=true"
import script from "./AddPetBreed.vue?vue&type=script&lang=js"
export * from "./AddPetBreed.vue?vue&type=script&lang=js"

import "./AddPetBreed.vue?vue&type=style&index=0&id=c9b3ab90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b3ab90"]])

export default __exports__